import { Pipe, PipeTransform, inject } from '@angular/core';

import { AppConfig } from '@app/app.config';
import { Currency } from '@shared/models';
import { AdcCurrencyPipe } from '@shared/pipes/currency.pipe';

const DEFAULT_SPEND_THRESHOLD_MAP = {
    USD: 5000,
    EUR: 5000,
};

@Pipe({
    name: 'spend',
})
export class SpendPipe implements PipeTransform {
    private readonly appConfig = inject(AppConfig);
    private readonly adcCurrencyPipe = inject(AdcCurrencyPipe);

    transform(
        spendValue: number | string,
        currency: Currency,
        shortValuePrecision = 1,
        shortFormat = false,
        naStr?: string,
    ): string {
        if (spendValue == null) {
            return naStr ?? 'N/A';
        }

        const returnValue = String(spendValue);

        let spendThresholdMap = this.appConfig.settings?.settings?.spend_threshold_map as Record<string, number>;

        if (!spendThresholdMap) {
            spendThresholdMap = DEFAULT_SPEND_THRESHOLD_MAP;
        }

        if (+returnValue === 0 || !spendThresholdMap[currency.code]) {
            return this.adcCurrencyPipe.transform(returnValue, currency, shortValuePrecision, shortFormat, naStr);
        }

        if (spendThresholdMap[currency.code] > +spendValue) {
            return `<${this.adcCurrencyPipe.transform(spendThresholdMap[currency.code], currency, shortValuePrecision, shortFormat, naStr)}`;
        }

        return this.adcCurrencyPipe.transform(returnValue, currency, shortValuePrecision, shortFormat, naStr);
    }
}
